import { IClientDemandsTable, IDemandsTable } from 'types/demandsTable';
import api from '../services/config/api';

export const getDemandsData = (query?: string) =>
  api.get<IDemandsTable>(`/solicitacao/filter?archived=false&${query || ''}`);

type sn = string | number | undefined;
export interface IGCDDParams extends Record<string, sn> {
  size: number;
  page?: number;
}
export const getClientDemandsData = (query: IGCDDParams) =>
  api.get<IClientDemandsTable>(`/solicitacao/documentos-consultas/filter`, {
    params: query,
  });

export const getDemandsArchived = (query?: string) =>
  api.get<IDemandsTable>(`/solicitacao/filter?archived=true&${query}`);
